// 转化rem单位 1rem = 100px
// PC端适配
(function (doc, win, pwidth, prem) {
    var docEl = doc.documentElement,
        resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
        recalc = function () {
            // var clientWidth = docEl.clientWidth;  //不足以适应放大缩小屏幕
			var clientWidth = window.innerWidth;
            if (!clientWidth) return;
            docEl.style.fontSize = clientWidth / pwidth * prem + 'px';
        };
    if (!doc.addEventListener) return;
    win.addEventListener(resizeEvt, recalc, false);
    doc.addEventListener('DOMContentLoaded', recalc, false);
})(document, window, 1920, 100);